// extracted by mini-css-extract-plugin
module.exports = {"uploadButton":"index_uploadButton__2TWbT","uploadButton_tip":"index_uploadButton_tip__1VUMm","tip":"index_tip__3jtjS","videoTip":"index_videoTip__2De6n"};